import {sortConstants, minimunDate} from '../../../util/uiconstants';

const normalizeDocuments = (documents) => {
	return documents?.map((document) => {
		return {...document, documentTypeId: document.documentType};
	});
};

const normalizeInstructions = (sections) => {
	return sections?.map(
		({instructionSectionId, instructionSectionName, isCustom, knowledgeInstructionSectionId, instructions}) => {
			return {
				id: instructionSectionId,
				sectionName: instructionSectionName,
				isCustom,
				knowledgeInstructionSectionId,
				instructions: instructions?.map(
					({
						gaInstructionGuid,
						gaInstructionName,
						gaInstructionDescription,
						dueDate,
						isCustom,
						knowledgeDisplayOrder,
						associatedDocuments
					}) => {
						return {
							id: gaInstructionGuid,
							instructionName: gaInstructionName,
							instructionSectionId,
							instructionDescription: gaInstructionDescription,
							dueDate: minimunDate.includes(dueDate) ? null : dueDate,
							isCustom,
							knowledgeDisplayOrder: knowledgeDisplayOrder || sortConstants.knowledgeDisplayOrder,
							documents: normalizeDocuments(associatedDocuments),
							documentsCount: associatedDocuments?.length > 0 ? associatedDocuments.length : '-'
						};
					}
				)
			};
		}
	);
};

export default (groupSnapshot) => {
	const normalizeGroupSnapshot = {
		id: groupSnapshot.snapshotID,
		componentId: groupSnapshot.gaComponentID,
		date: groupSnapshot.snapshotDate,
		hasValue: groupSnapshot.hasValue,
		instructionJson: {
			accounts: groupSnapshot.instructionJson.accounts,
			instructionSentDate: groupSnapshot.instructionJson.instructionSentDate,
			docServiceBaseUri: groupSnapshot.instructionJson.docServiceBaseUri,
			hashValue: groupSnapshot.instructionJson.hashValue,
			instructionSections: normalizeInstructions(groupSnapshot.instructionJson.instructionSections)
		}
	};
	return normalizeGroupSnapshot;
};
